import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Ellipsis } from 'components';

const Wrapper = styled.div`
  ${({ valid }) => !valid && 'color: #c3ced9;'}
  height: 47px;

  p{
    padding: 14px 20px;

    span.numberHolder{
      display: inline-block;
      width: 28px;
      height: 28px;
      margin-top: -4px;
      margin-right: 10px;
      border-radius: 14px;
      line-height: 28px;
      text-align: center;
      background-color: #ecf2f8;
      color: #334d66;
    }
  }
`;

const GuestText = ({ text, number, title, valid, guestId, departureId, dispatch, ...props }) => (
  <Wrapper valid={valid}>
    <Ellipsis {...props} title={title}>
      {number ? <span className="numberHolder">{number}</span> : null }
      {text}
    </Ellipsis>
  </Wrapper>
);
GuestText.propTypes = {
  guestId: PropTypes.string,
  departureId: PropTypes.string,
  valid: PropTypes.bool,
  text: PropTypes.string,
  number: PropTypes.string,
  title: PropTypes.string,
  dispatch: PropTypes.func,
};
export default GuestText;



// WEBPACK FOOTER //
// ./src/components/molecules/GuestText/index.js